import { Sheet } from '@iris/react-components/Sheet';

import { usePriceAlertSubmit } from '@/hooks/usePriceAlertSubmit.js';

import EmailSubscribeForm from '@/components/EmailSubscribeForm';

/**
 * A modal sheet component for vehicle price alert subscription.
 *
 * This component renders a modal overlay containing an email subscription form
 * that allows users to sign up for price alerts on a specific vehicle. It uses
 * the Iris Sheet component for the modal behavior and integrates with the
 * usePriceAlertSubmit hook for form submission logic.
 *
 * @param {Object} props - The component props
 * @param {React.ReactNode} props.trigger - The trigger element that opens the sheet.
 *   Can be any React element (button, div, custom component, etc.).
 *   When null/undefined, the component returns null.
 * @param {string} [props.className=''] - Additional CSS classes to apply to the wrapper div
 *
 * @returns {React.ReactNode|null} The rendered sheet component or null if no trigger provided
 */
export default function PriceAlertSheet({ trigger, className = '' }) {
    const {
        onPriceAlertSubmit,
        showPriceAlertError,
        showPriceAlertSuccess,
    } = usePriceAlertSubmit();

    if (!trigger) {
        return null;
    }

    return (
        <div
            data-cmp="priceAlertSheet"
            className={className}
        >
            <Sheet
                trigger={trigger}
                desktopPosition="center"
                title="Sign Up for Price Alerts"
                bodyClassName="iris:w-full iris:md:w-[376px]"
                modal
            >
                <EmailSubscribeForm
                    isNotInlineForm
                    onSubmit={onPriceAlertSubmit}
                    borderRadius="inset"
                    registrationError={showPriceAlertError ? 'Due to a server error, we were unable to complete your request to receive price alerts. Please try again later.' : undefined}
                    registrationSuccess={showPriceAlertSuccess ? "Success! You'll now receive price alerts." : undefined}
                />
            </Sheet>
        </div>
    );
}
